import { DELETEResponse, POSTEmployeeSkillBody, PUTEmployeeSkillBody } from '@cbgms/api'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

export const loadEmployeeSkills = (params: any) => ({
  method: 'GET',
  url: '/modules/employee-skill',
  params
})

export const loadEmployeeSkill = (uuid: string) => ({
  method: 'GET',
  url: `/modules/employee-skill/${uuid}`
})

export const createEmployeeSkill = (body: POSTEmployeeSkillBody) => ({
  method: 'POST',
  url: '/modules/employee-skill',
  data: body
})

export const updateEmployeeSkill = (uuid: string, body: PUTEmployeeSkillBody) => ({
  method: 'PUT',
  url: `/modules/employee-skill/${uuid}`,
  data: body
})

export const deleteEmployeeSkill = (uuid: string, DryRun: boolean) => ({
  method: 'DELETE',
  url: `/modules/employee-skill/${uuid}`,
  params: {
    DryRun
  }
})

// deleteEmployeeSkill is also being used inside an action that is being used for the
// employee skill edit page, but the new delete button requires the DELETEResponse type as promise
// return type, so that's why a second request function was made.
export const deleteEmployeeSkillAsyncApiAction = (uuid: string, DryRun: boolean) =>
  createAsyncApiAction<DELETEResponse>('gms', {
    method: 'DELETE',
    url: `/modules/employee-skill/${uuid}`,
    params: {
      DryRun
    }
  })

export const loadAllEmployeeSkills = () => ({
  method: 'GET',
  url: '/modules/employee-skill',
  params: {
    PerPage: 99999,
    Fields: 'Title,UUID'
  }
})
